import React, { useState } from "react";
import { auth, db } from "../../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/OSM-logo.png";

const Register = () => {
    const [formData, setFormData] = useState({
        voornaam: "",
        achternaam: "",
        telefoon: "",
        email: "",
        wachtwoord: "",
        bedrijf: "",  // <-- Toevoegen van het 'bedrijf' veld
        role: "agent", // Zorg ervoor dat de rol hier wordt toegevoegd
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        const { email, wachtwoord, voornaam, achternaam, telefoon, bedrijf, role } = formData;

        try {
            const userCred = await createUserWithEmailAndPassword(auth, email, wachtwoord);

            await setDoc(doc(db, "users", userCred.user.uid), {
                voornaam,
                achternaam,
                telefoon,
                email,
                profielfotoUrl: "", // Zet een leeg veld voor de profielfoto
                bedrijf,  // Zet het bedrijf op de Firestore database
                role,     // Voeg de rol toe, standaard 'agent'
            });

            navigate("/dashboard");
        } catch (err) {
            console.error(err);
            alert("Registreren mislukt");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
            <div className="bg-white p-8 rounded shadow-md w-full max-w-md space-y-4">

                {/* 👇 Logo + Titel */}
                <div className="text-center mb-4">
                    <img src={logo} alt="Logo" className="h-12 mx-auto mb-2" />
                    <h2 className="text-2xl font-semibold">Account aanmaken</h2>
                </div>

                {/* 🔐 Formulier */}
                <form onSubmit={handleRegister} className="space-y-4">
                    <div className="flex gap-2">
                        <input
                            type="text"
                            name="voornaam"
                            placeholder="Voornaam"
                            value={formData.voornaam}
                            onChange={handleChange}
                            className="w-1/2 border rounded px-3 py-2"
                            required
                        />
                        <input
                            type="text"
                            name="achternaam"
                            placeholder="Achternaam"
                            value={formData.achternaam}
                            onChange={handleChange}
                            className="w-1/2 border rounded px-3 py-2"
                            required
                        />
                    </div>

                    {/* Nieuw veld voor Bedrijf */}
                    <input
                        type="text"
                        name="bedrijf"
                        placeholder="Bedrijf"
                        value={formData.bedrijf}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                    />

                    <input
                        type="tel"
                        name="telefoon"
                        placeholder="Telefoonnummer"
                        value={formData.telefoon}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                        required
                    />

                    <input
                        type="email"
                        name="email"
                        placeholder="E-mailadres"
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                        required
                    />

                    <input
                        type="password"
                        name="wachtwoord"
                        placeholder="Wachtwoord"
                        value={formData.wachtwoord}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                        required
                    />

                    <button
                        type="submit"
                        className="w-full bg-[#175151] text-white py-2 rounded hover:bg-[#148c87] transition"
                    >
                        Registreren
                    </button>
                </form>

                <p className="text-sm text-center text-gray-600 mt-4">
                    Al een account?{" "}
                    <a href="/login" className="text-[#175151] hover:underline font-medium">
                        Log in
                    </a>
                </p>
            </div>
        </div>
    );
};

export default Register;
